import React from "react";
import { Link } from "react-router-dom";

const AfricanPenguinImg = "/Images/Containerrs.png";

const AfricanPenguin = () => {
  return (
    <>
    <section
      className="vh-100 position-relative"
      style={{
        backgroundImage: `url(${AfricanPenguinImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,.15), rgba(0,0,0,.45))"
        }}
      />

      <div className="container-fluid h-100 position-relative">
        <div className="row h-100 align-items-center">
          <div className="col-lg-7 col-md-9">

            <div
              className="text-white"
              style={{
                marginLeft: "40px",
                marginTop: "80px"
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-3">

                <small
                  className="fw-semibold"
                  style={{
                    letterSpacing: "1px"
                  }}
                >
                  ← All Species
                </small>

                <span
                  className="badge bg-danger px-3 py-2"
                  style={{
                    fontSize: "9px",
                    letterSpacing: "1px"
                  }}
                >
                  CRITICALLY ENDANGERED
                </span>

              </div>

              <h1
                className="fw-normal mb-4"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "5rem",
                  lineHeight: ".95"
                }}
              >
                African
                <br />
                Penguin
              </h1>

              <p
                className="fst-italic mb-4"
                style={{
                  fontSize: "18px",
                  color: "rgba(255,255,255,.85)"
                }}
              >
                Spheniscus demersus · Coastal islands & mainland beaches · Southern Africa
              </p>

              <hr
                className="border-light opacity-75"
                style={{
                  width: "520px"
                }}
              />

              <div className="d-flex gap-5 mt-4">

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    &lt;97%
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                   POPULATION LOST SINCE 1900S
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    &lt;10,000
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                   BREEDING PAIRS LEFT
                  </small>
                </div>

                <div>
                  <h2
                    className="fw-normal mb-1"
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "3rem"
                    }}
                  >
                    2035
                  </h2>

                  <small
                    className="text-uppercase"
                    style={{
                      letterSpacing: "1px"
                    }}
                  >
                    PROJECTED WILD EXTINCTION
                  </small>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </section>

    <section
  className="py-5"
  style={{
    background: "#f5f3ee"
  }}
>
  <div
    className="container"
    style={{
      maxWidth: "1100px"
    }}
  >
    <div className="row g-5">

      {/* LEFT SIDEBAR */}

      <div className="col-lg-3">

        <div
          className="p-4 mb-4"
          style={{
            background: "#ece9e2"
          }}
        >
          <h6
            style={{
              fontFamily: "Georgia, serif"
            }}
          >
            Support This Work
          </h6>

          <p
            className="small text-muted"
          >
            Field research, community programs, and habitat
            protection all depend on donations.
          </p>

          <button
            className="btn w-100 text-white rounded-0"
            style={{
              background: "#6d735d"
            }}
          >
            <Link to="/donate" style={{ textDecoration: "none", color: "white" }}>
              DONATE
            </Link>
          </button>
        </div>

        <small
          className="text-uppercase text-muted"
          style={{
            fontSize: "10px",
            letterSpacing: "2px"
          }}
        >
          Related Articles
        </small>

        <div className="border-top py-3">
          <Link to="/southern-grounded-hornbill" className="text-decoration-none text-dark">
            <div>Southern Ground Hornbill →</div>
          </Link>
          <small className="text-muted">
            Vulnerable
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/bearded-vulture" className="text-decoration-none text-dark">
            <div>Bearded Vulture →</div>
          </Link>
          <small className="text-muted">
            Nearly Threatened
          </small>
        </div>

        <div className="border-top py-3">
          <Link to="/cape-gannet" className="text-decoration-none text-dark">
            <div>Cape Gannet →</div>
          </Link>
          <small className="text-muted">
            Endangered
          </small>
        </div>

      </div>

      {/* MAIN CONTENT */}

      <div className="col-lg-9">

        <div className="row mb-5">

          <div className="col-lg-7">
            <p
              className="text-secondary"
              style={{
                lineHeight: "2",
                fontSize: "14px"
              }}
            >
              Africa's only penguin charismatic, monogamous, and unmistakable with its polka-dot chest and donkey-like bray — once numbered over a million birds. Today fewer than 10,000 breeding pairs survive. In 2024 it was officially uplifted to Critically Endangered. Scientists warn it could be functionally extinct in the wild by 2035. It would be the first penguin species to go extinct in modern times.
            </p>
          </div>

          <div className="col-lg-5">

            <div className="row text-center"
            style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}
             >

              <div className="col-4">
                <p>6.8 lbs (3 kgs)</p>
                <small style={{
                   color: "#888",
                }}>Average Weight</small>
              </div>

              <div className="col-4">
                <p>26.5–27.5 in (67.31–69.85 cm)</p>
                <small  style={{
                   color: "#888",
                }}>Average Height</small>
              </div>

              <div className="col-4">
                <p>20 years</p>
                <small  style={{
                   color: "#888",
                }}>Average Lifespan</small>
              </div>

            </div>

          </div>

        </div>

        {/* PERSONAL NOTE */}

        <div
          className="bg-white p-4 mb-4 border-start border-warning border-3"
        >
          <small
            className="text-uppercase text-warning fw-bold"
          >
            A Personal Note
          </small>

          <p
            className="fst-italic mt-3 mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "18px"
            }}
          >
            "The African penguin stat that stopped me cold: a 97%
decline since the 1900s. That's not a trend. That's a
collapse. And it's still happening."
          </p>
        </div>

        {/* STATUS */}

        <div
          className="text-white p-4 mb-5"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Conservation Status
          </small>

          <p className="mb-0 mt-2">
            The African Penguin was officially uplisted from Endangered to Critically Endangered by the IUCN in July 2024. The population has collapsed from an estimated 1.5 to 3 million individuals at the turn of the 20th century to fewer than 20,000 mature individuals today a decline of 93 to 97 percent. Scientists warn that without immediate action, fewer than 50 breeding pairs will remain by 2035.
          </p>
        </div>

        {/* TROUBLE */}

        <h2
          className="mb-5"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          Why This Species Is In Trouble
        </h2>

        <div className="position-relative mb-5">

          <div
            className="position-absolute"
            style={{
              left: "4px",
              top: 0,
              bottom: 0,
              width: "1px",
              background: "#ddd"
            }}
          />

          {[
            {
              title: "Industrial Overfishing",
              text: "For decades, commercial fishing fleets have stripped the Benguela Current of the sardines and anchovies African penguins evolved to eat. The penguins are locked into fixednesting sites they can’t follow the fish. Parents return from days at sea empty-handed, and chicks starve."
            },
            {
              title: "Oil Spills",
              text: "The southern African coastline is one of the world’s busies  shipping lanes. Oil spills both accidental and from ships illegally flushing tanks coat penguin feathers, destroying their waterproofing and insulation. Oiled penguins cannot swim,cannot regulate their body temperature, cannot feed."
            },
            {
              title: "Climate Change",
              text: "As ocean temperatures rise and currents shift, sardine and anchovy populations are moving southward away from historic breeding colonies. The penguins, bound to fixed nestingsites, cannot follow. Rising temperatures are also causing deadly heat stress in eggs and chicks."
            },
            {
              title: "Habitat Loss on Breeding Islands",
              text: "Competition for nesting space, disturbance from tourism, and the removal of guano which penguins traditionally burrow into have eliminated nesting habitat across key islands. Withoutdeep burrows, eggs are exposed to predators and extreme sun."
            }
          ].map((item, index) => (
            <div
              className="d-flex mb-5"
              key={index}
            >
              <div
                className="rounded-circle me-4 mt-2"
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#c98d2c",
                  zIndex: 2
                }}
              />

              <div>
                <h6
                  style={{
                    fontFamily: "Georgia, serif"
                  }}
                >
                  {item.title}
                </h6>

                <p
                  className="text-muted"
                  style={{
                    fontSize: "13px",
                    lineHeight: "1.8"
                  }}
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}

        </div>

        {/* QUOTE */}

        <div
          className="text-white p-5 my-5"
          style={{
            background: "#6d735d"
          }}
        >
          <div
            style={{
              fontSize: "40px",
              color: "#e0b04b"
            }}
          >
            "
          </div>

          <p
            className="fst-italic mb-0"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "24px"
            }}
          >
            At the current rate of decline, the African penguin could be functionally extinct in the wild within a decade. It would be the first penguin species to go extinct in modern times.
          </p>
        </div>

        {/* ACTIONS */}

        <h2
          className="mb-4"
          style={{
            fontFamily: "Georgia, serif"
          }}
        >
          We're supporting the following activities
        </h2>

        <div className="d-flex flex-column gap-2 mb-5">

          {[
            "Rescue and rehabilitation of oiled penguins at coastal centers",
            "Installing artificial burrows at key breeding colonies",
            "Advocating for fishing exclusion zones near nesting sites",
            "GPS tracking to understand feeding range and food availability"
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white border px-3 py-3"
            >
              <span
                className="me-2"
                style={{
                  color: "#c98d2c"
                }}
              >
                ○
              </span>

              {item}
            </div>
          ))}

        </div>

        {/* IMAGE BLOCK */}

        <div
          className="p-4 text-white"
          style={{
            background: "#6d735d"
          }}
        >
          <small
            className="text-uppercase"
            style={{
              letterSpacing: "2px"
            }}
          >
            Reasons For Hope
          </small>

          <p className="mt-2">
           SANCCOB has rehabilitated over 100,000 seabirds since 1968. Artificial burrow programs are improving breeding success. The fishing exclusion zone debate is gaining political momentum in South Africa.
          </p>

          <img
            src="/Images/Container2.png"
            alt=""
            className="img-fluid w-100"
          />
        </div>

      </div>

    </div>
  </div>
</section>
    
    </>
  );
};

export default AfricanPenguin;
